<template>
  <v-row>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Bettina"
                   image-src="/Bilder/Akteure/Bettina.jpg"
      >Theater das ist die Arbeit mit mir selbst, mit dem Part, der sonst im Exil lebt.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Thomas"
                   image-src="/Bilder/Akteure/Thomas.jpg"
      >Die gemeinsame Arbeit mit Regie und Ensemble eröffnet immer wieder neue Facetten und überraschende Deutungen
        einer Szene. Die Freude am Spiel entsteht im Zusammenspiel auf der Bühne und mit dem Publikum – einfach einzigartig!
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Doris"
                   image-src="/Bilder/Akteure/Doris.png"
      >Warum ich Theater spiele?<br><br>
        Ganz einfach,<br><br>
        Es macht mir wahnsinnig viel Spaß.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Rene"
                   image-src="/Bilder/Akteure/Rene.jpg"
      >Immer wieder etwas Neues ausprobieren, in andere Rollen schlüpfen, Blickwinkel ändern und somit
        vielleicht auch etwas über sich selbst lernen.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Yuko"
                   image-src="/Bilder/Akteure/Yuko.jpg"
      >Warum spiele ich Theater? Weil es dort ein Publikum gibt.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Heidi"
                   image-src="/Bilder/Akteure/Heidi.jpg"
      >Dem inneren Zensor mal den Stinkefinger zeigen und eine ganze Palette an möglichen
        Gefühlszuständen durchleben zu können/dürfen/müssen ist meine größte Faszination und
        Herausforderung.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Nicki"
                   image-src="/Bilder/Akteure/Nicki.jpg"
      >Das Abtauchen, sich einlassen auf; erforschen verschiedener Menschentypen in allen Facetten.<br>
        Dinge tun, die man sonst nie tun würde - Urlaub von sich selbst nehmen,<br>
        mit anderen sich auf die Reise begeben und sich dadurch doch selbst entdecken!
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Stefan"
                   image-src="/Bilder/Akteure/Stefan.jpg"
      >Theater spielen heißt für mich mehr als nur in Rollen schlüpfen oder Bühnenbretter erobern.
        Es bedeutet für mich auch in Emotionen und Leidenschaften, überhaupt in die Gefühlswelt abzutauchen und
        sich dabei spielerisch ein Stück weit selbst zu entdecken.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Max"
                   image-src="/Bilder/Akteure/Max.jpg"
      >Theater ist wie Achterbahn fahren: ein ständiges Auf und Ab. Erst geht’s rauf auf die Bühne,
        dann geht’s ab im Publikum. Und am Ende stehen alle auf und klatschen.
        Das passiert mir im Büro nie, obwohl ich da auch täglich eine Show abliefere.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Julia"
                   image-src="/Bilder/Akteure/Julia.jpg"
      >Theater ist für mich die Freiheit, immer wieder jemand anderes zu sein - denn warum nur ein Leben leben,
        wenn man so viele spielen kann.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Marina"
                   image-src="/Bilder/Akteure/marina.png"
      >Es ist wichtig Gesicht zu zeigen, aber am Text muss ich noch feilen... 😊
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Victoria"
                   image-src="/Bilder/Akteure/Victoria.jpg"
      >Wieso ich Theater spiele?  Es macht zu viel Spaß, um es nicht zu tun.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Carola"
                   image-src="/Bilder/Akteure/Carola.jpg"
      >Es macht großen Spaß in verschiedene Charaktere zu schlüpfen und auch  das Singen und Tanzen...
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Silke"
                   image-src="/Bilder/Akteure/Silke.jpg"
      >Ich spiele Theater, weil meine innere Rampensau ab und zu Auslauf braucht 🐷😜
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Hildegard"
                   image-src="/Bilder/Akteure/Hildegard.jpg"
      >Immer auf der Suche nach dem Flow…….um sich frei zu fühlen.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Katharina"
                   image-src="/Bilder/Akteure/Katharina.jpg"
      >Ich spiele Theater, weil ich jemand anderes sein, in verschiedene Charaktere schlüpfen und dabei ganz neue Gefühle erleben darf. Es gibt mir die Freiheit, auch mal verrückt zu sein und aus dem Alltag auszubrechen. Für mich ist Theater eine schöne Auszeit aus dem normalen Leben...und was ist schon normal.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Sousan"
                   image-src="/Bilder/Akteure/Sousan.jpg"
      > Für mich bedeutet Theater, Wandlung, Kreativität, Metamorphose, Leidenschaft, unfassbarer Spaß!
        Reisen in und durch andere Welten… ❤️
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Hans-Christian"
                   image-src="/Bilder/Akteure/Hans_Christian.jpg"
      >Sein können, was man sonst nicht sein darf.<br>
        Sein dürfen, was man sonst nicht sein kann.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Jana"
                   image-src="/Bilder/Akteure/Jana.jpg"
      >Ich spiele gerne Theater, weil ich dort...
        böse, skurril, dumm, verzweifelt, lustig, schön, hässlich, angeberisch, ironisch, sarkastisch,
        verliebt, gewitzt, lächerlich und vieles mehr sein kann.<br>
        Alles was ich im realen Leben nicht immer sein darf.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Ronaro"
                   image-src="/Bilder/Akteure/Ronaro.jpg"
      > Mit Theater bringe ich Leute zum Lachen und zum Weinen, aber vor allem zum Denken ...
        ohne viel erklären zu müssen.<br>
        Mit Theater kann ich lieben und geliebt werden, töten und getötet werden ...
        danach gehe ich schlafen, und morgen geht alles wieder von vorne los.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Carsten"
                   image-src="/Bilder/Akteure/Carsten.jpg"
      >Theater ist ein vielseitiges, anspruchsvolles und verführerisches Spiel im Team....<br>
        mit anerkennendem Applaus als Belohnung.
        Auf der Bühne ist alles erlaubt, niemand versteckt sich.
        Man kann multiple, verrückte Seiten seiner Persönlichkeit ausleben,
        ohne dass man gleich für irre erklärt wird. Das ist großartig!
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Constanze"
                   image-src="/Bilder/Akteure/Constanze.jpg"
      > Ich spiele Theater seit ich klein bin und wüsste nicht, warum ich jemals damit aufhören sollte.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Sabine"
                   image-src="/Bilder/Akteure/Sabine.jpg"
      >Theater ist für mich mehr als ein Hobby!
        Es ist eher eine "Lebensweise", eine Welt, in der ich alles ausprobieren kann.<br>
        Ich liebe es, mich mit Theater zu beschäftigen,
        vor, auf, hinter und unter (!?!) der Bühne...
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Mario"
                   image-src="/Bilder/Akteure/placeholder_man.png"
      >Große Zufriedenheit entsteht, wenn sich szenische Arbeiten, Geräusche, Musik und Licht langsam
        (oder schneller) zu einem funktionierenden Theaterabend zusammenfügen...
        ...vielleicht bin ich auch bloß so eine "Rampensau", die sich auch noch gern um die Technik
        kümmert.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Gerlinde"
                   image-src="/Bilder/Akteure/placeholder_woman.png"
      >Theater ist gespiegeltes Leben.
        Um das Dabeisein, um das Miteinander geht es mir. Mitzuerleben, wie ein Stück "wird", wie es
        allmählich
        Gestalt annimmt. Von der Textvorlage bis hin zur Aufführung.
        Dieser so spannende Prozess ist es.
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Ursula"
                   image-src="/Bilder/Akteure/placeholder_woman.png"
      > Rollen von skurril bis normal, lustig bis traurig, gut bis böse, ehrlich bis scheinheilig,
        sanft
        bis brutal, brav bis verrückt:
        Einfach alle Lebensfacetten mit Spaß in der Gruppe durchspielen und erleben!
      </akteur-card>
    </v-col>
    <v-col cols="12" lg="6">
      <akteur-card class="mt-2"
                   name="Christian"
                   image-src="/Bilder/Akteure/placeholder_man.png"
      >Weil auch eine multiple Persönlichkeit ein entsprechendes Hobby braucht und man sich unter
        Gleichgesinnten einfach besser verstanden fühlt...
      </akteur-card>
    </v-col>
  </v-row>
</template>

<script>

import AkteurCard from "./AkteurCard";

export default {
  name: "AkteureAktiv",
  components: {AkteurCard},
}
</script>

<style scoped>

</style>